import { Box } from '@mui/material';

import CustomizedSwitch from 'components/SwitchButton/SwitchButton';

const PriceSettingToggle: React.FC<{
  title: string;
  description: string;
  action: () => void;
  isOn: boolean;
  disabled: boolean;
}> = ({ title, description, action, isOn, disabled }) => {
  return (
    <Box className="settings-card mt-4 flex flex-row items-center justify-between p-9">
      <Box style={{ maxWidth: '50%' }}>
        <h3 className="text-base-cardForeground font-semibold">{title}</h3>
        <p className="mt-2 small-text">{description}</p>
      </Box>
      <Box>
        <Box className="buttons-wrapper">
          <CustomizedSwitch
            tooltip={''}
            status={isOn}
            texts={[]}
            functions={[() => action(), () => action()]}
            disabled={disabled}
            color="black"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PriceSettingToggle;
